import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import Close from "../../../../assets/Close.svg";
import OpenIcon from "../../../../assets/AccOptionIcon.svg";
import "./style.scss";

type Row = {
  label: string;
  value: string | undefined | null;
};

type DividendRow = {
  date: string;
  amount: string;
  yield?: string;
};

type CouponRow = {
  date: string;
  amount: string | null;
};

type PropsType = {
  title: string;
  content?: string;
  htmlContent?: React.ReactNode;
  bottomSheetContent?: boolean;
  rows?: Row[];
  infoRows?: Row[];
  dividendRows?: DividendRow[];
  couponRows?: CouponRow[] | null;
  customClick?: () => void;
  custom?: boolean;
};

export const AssetWidgetAndBottomSheet: FC<PropsType> = ({
  title,
  content,
  htmlContent,
  bottomSheetContent,
  rows,
  infoRows,
  dividendRows,
  couponRows,
  customClick,
  custom,
}) => {
  const { t } = useTranslation("app");
  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
  const visibleRows = rows && rows.filter((row) => row.value).slice(0, 3);

  const renderRows = (rowsToRender: Row[]) =>
    rowsToRender
      .filter((row) => row.value)
      .map((row, idx) => (
        <div className="asset-description-row" key={idx}>
          <span className="asset-description-label">{t(row.label)}</span>
          <span className="asset-description-value">{row.value}</span>
        </div>
      ));

  const renderTableRows = (rows: DividendRow[]) => (
    <table className="asset-dividends-table">
      <thead>
        <tr>
          <th style={{ textTransform: "capitalize" }}>{t("date")}</th>
          <th style={{ textTransform: "capitalize", textAlign: "right" }}>
            {t("price")}
          </th>
          {/* <th>Доход</th> */}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            <td>{row.date}</td>
            <td style={{ textAlign: "right" }}>{row.amount}</td>
            {/* <td>{row.yield}</td> */}
          </tr>
        ))}
      </tbody>
    </table>
  );

  const renderCouponTableRows = (rows: CouponRow[]) => (
    <table className="asset-dividends-table">
      <thead>
        <tr>
          <th>{t("payment_date")}</th>
          <th style={{ textAlign: "right" }}>{t("coupon")}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            <td>{row.date}</td>
            <td style={{ textAlign: "right" }}>{row.amount}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div className="asset-description-widget">
      <p className="asset-description-title">
        {title ? t(title) : <></>}
        <button
          onClick={() => {
            if (customClick) {
              customClick();
            } else {
              setBottomSheetOpen(true);
            }
          }}
        >
          <img src={OpenIcon} alt="open" />
        </button>
      </p>

      {custom && (
        <p
          className="asset-description-content"
          dangerouslySetInnerHTML={{ __html: t("foundDescription") }}
        />
      )}

      {content && <p className="asset-description-content">{content}</p>}

      {htmlContent && (
        <div className="asset-description-content">{htmlContent}</div>
      )}

      {visibleRows && (
        <div className="asset-dividends-rows">{renderRows(visibleRows)}</div>
      )}

      {bottomSheetOpen && (
        <div
          className="asset-description-bottomsheet-overlay"
          onClick={() => setBottomSheetOpen(false)}
        >
          <div
            className="asset-description-bottomsheet"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="asset-description-header">
              <p>{t(title)}</p>

              <button
                onClick={() => setBottomSheetOpen(false)}
                aria-label="close"
              >
                <img src={Close} alt="Close" />
              </button>
            </div>

            {custom && (
              <p
                className="asset-description-info"
                dangerouslySetInnerHTML={{ __html: t("foundDescription") }}
              />
            )}

            {(content || bottomSheetContent) && (
              <p className="asset-description-info">
                {bottomSheetContent ? bottomSheetContent : content}
              </p>
            )}
            {!bottomSheetContent && rows && (
              <div className="asset-description-rows">{renderRows(rows)}</div>
            )}
            {infoRows && (
              <div className="asset-description-title">{t("info")}</div>
            )}
            {infoRows && (
              <div className="asset-description-rows">
                {renderRows(infoRows)}
              </div>
            )}

            {dividendRows && renderTableRows(dividendRows)}

            {couponRows && renderCouponTableRows(couponRows)}
          </div>
        </div>
      )}
    </div>
  );
};
